import { useTheme } from "next-themes"
import { Toaster as Sonner, toast } from "sonner"

const Toaster = ({
  toastOptions,
  ...props
}) => {
  const { theme = "system" } = useTheme()

  return (
    <Sonner
      theme={theme === "light" ? "light" : "dark"}
      className="toaster group prysm-toaster"
      position="bottom-center"
      richColors={false}
      closeButton
      toastOptions={{
        ...toastOptions,
        style: {
          zIndex: 9999,
          ...(toastOptions?.style || {}),
        },
        classNames: {
          toast: "prysm-toast group toast",
          title: "prysm-toast-title",
          description: "prysm-toast-description",
          success: "prysm-toast-success",
          error: "prysm-toast-error",
          warning: "prysm-toast-warning",
          info: "prysm-toast-info",
          loading: "prysm-toast-loading",
          actionButton:
            "group-[.toast]:bg-[#f76f4b] group-[.toast]:text-white",
          cancelButton:
            "group-[.toast]:bg-muted group-[.toast]:text-muted-foreground",
          closeButton: "prysm-toast-close",
          ...(toastOptions?.classNames || {}),
        },
      }}
      {...props}
    />
  );
}

export { Toaster, toast }
